import axios from './axiosInstance';
import { jsonToFormData } from "./converters";

export const exercisesList = async (params = {}) => {
  const response = await axios.get("/club_api/exercises", { params });
  return response.data;
};


export const newExercise = async () => {
  const response = await axios.get("/club_api/exercises/new");
  return response.data;
};

export const exerciseDetails = async (id) => {
  const response = await axios.get("/club_api/exercises/" + id);
  const data = response.data;
  if (typeof data.exercise.diagram_data === 'string') {
    data.exercise.diagram_data = JSON.parse(data.exercise.diagram_data)
  }

  return data;
};

export const copyExercise = async (id) => {
  const response = await axios.get("/club_api/exercises/" + id + "/copy");
  return response.data;
};

export const exerciseAddons = async () => {
  const response = await axios.get("/club_api/exercises/exercise_addons" );
  return response.data;
};

export const removeExercise = async (id) => {
  const response = await axios.delete("/club_api/exercises/" + id);
  return response.data;
};

export const exerciseCategoriesList = async () => {
  const response = await axios.get("/club_api/exercises/categories" );
  return response.data;
};

export const saveExercise = async (exercise) => {
  const headers = { 'Content-Type': 'multipart/form-data' }
  const formData = jsonToFormData(exercise, "exercise")
  const response = !exercise?.id
    ? await axios.post("/club_api/exercises/", formData, { headers })
    : await axios.put("/club_api/exercises/" + exercise.id, formData, { headers });
  return response.data;
};